import React from 'react';
import { useTranslation } from 'react-i18next';
import UndoButton from '../../Util/Buttons/UndoButton/UndoButton';
import { isMobile } from '../../../services/booleanUtil';

type Props = {
  isAgenda: boolean;
  editable?: boolean;
  handleOnclck: any;
  revision: any;
};
const ReportEditListButtons = ({ isAgenda, editable, handleOnclck, revision }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      {editable ? (
        <UndoButton
          customStyle={isMobile() ? { display: 'none' } : {}}
          customText={t('edit_list')}
          handleClick={handleOnclck}
        />
      ) : null}
    </>
  );
};

export default ReportEditListButtons;
